import Base from './Base';

class Landings extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'landings';
    }

    registerVisit = (site,variation,online_to) => {
        return  fetch(this.getUrlEndpoint(`hit/${site}/${variation}/${online_to}`),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default Landings;